import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/support/base.component';

export interface SampleSummaryDialogData {
  analytes: { name: 'string'; timesSelected: number }[];
}

export interface SampleSummaryDialogResult {
  success: boolean;
}

@Component({
  selector: 'app-sample-summary',
  templateUrl: './sample-summary.component.html',
  styleUrls: ['./sample-summary.component.scss'],
  standalone: false,
})
export class SampleSummaryDialog extends BaseComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SampleSummaryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SampleSummaryDialogData,
  ) {
    super();
  }

  protected ngOnDestroyInternal(): void {}

  ngOnInit(): void {}

  onCancel(): void {
    this.dialogRef.close({ success: false });
  }

  onContinue(): void {
    this.dialogRef.close({ success: true });
  }
}
